import { RootState } from '@app/redux/root-reducer';

export const selectNotificationSettings = (state: RootState) =>
  state.manageProfileSagasReducer.notificationSettings;

export const selectUserPreferences = (state: RootState) =>
  state.manageProfileSagasReducer.userPreferences;

export const selectMyProfile = (state: RootState) => state.manageProfileSagasReducer.myProfile;

export const selectMyProfileState = (state: RootState) =>
  state.manageProfileSagasReducer.profileForm;
